import React, { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import ProjectPageUI from '../../components/core-ui/project-page/project-page-ui'
import { projectsData } from '../../data/projectsData'
import { collectTags, filterProjects } from '../../utils/projectFilter'

function ProjectPage() {
    const [search, setSearch] = useState('')
    const [params, setParams] = useSearchParams()

    const tags = useMemo(() => collectTags(projectsData), [])
    // Only honour a ?tag= that really exists, so a stale link shows everything.
    const requested = params.get('tag') || ''
    const tag = tags.some((item) => item.tag === requested) ? requested : ''

    const setTag = (next) => {
        const updated = new URLSearchParams(params)
        if (next) updated.set('tag', next)
        else updated.delete('tag')
        setParams(updated, { replace: true })
    }

    const filteredArticles = filterProjects(projectsData, search, tag)

    return (
        <ProjectPageUI
            search={search}
            setSearch={setSearch}
            tags={tags}
            activeTag={tag}
            setTag={setTag}
            filteredArticles={filteredArticles}
        />
    )
}

export default ProjectPage
